import React from "react";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material";

export interface CustomDrawerProps {
  title?: React.ReactNode;
  handleOpen?: boolean;
  className?: string;
  onClose: () => void;
  variant?: "fullDrawer" | "medium" | "large" | "small";
  children?: React.ReactNode;
}

const StyledAppBar = styled(AppBar)(({ theme }: { theme: Theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  boxShadow: "none",
  background: "#fff",
  borderBottom: "1px solid #ddd",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const StyledTitle = styled(Typography)({
  flexGrow: 1,
});

const AppBarSpacer = styled("div")({
  height: 48,
});

const CustomDrawer: React.FC<CustomDrawerProps> = ({
  title,
  handleOpen = true,
  className = "",
  onClose,
  variant = "small",
  children,
}) => {
  return (
    <div>
      <Drawer
        anchor="right"
        className={`drawer-${variant} ${className}`}
        open={handleOpen}
        onClose={onClose}
      >
        {title && (
          <StyledAppBar color="default" position="absolute">
            <Toolbar variant="dense">
              <StyledTitle
                variant="h6"
                color="inherit"
                noWrap
                className="fw-semi-bold drawer-title"
              >
                {title}
              </StyledTitle>
              <Grid>
                <Button
                  size="small"
                  color="secondary"
                  variant="outlined"
                  onClick={onClose}
                >
                  Close
                </Button>
              </Grid>
            </Toolbar>
          </StyledAppBar>
        )}
        <section style={{ marginTop: "3rem" }}>
          {title && <AppBarSpacer />}
          {children}
          <br />
        </section>
      </Drawer>
    </div>
  );
};
export default CustomDrawer;